/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Related_Title_TailInputs */

const en_services_related_title_tail = /** @type {(inputs: Services_Related_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`together`)
};

const pl_services_related_title_tail = /** @type {(inputs: Services_Related_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`razem`)
};

/**
* | output |
* | --- |
* | "together" |
*
* @param {Services_Related_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_related_title_tail = /** @type {((inputs?: Services_Related_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Related_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_related_title_tail(inputs)
	return en_services_related_title_tail(inputs)
});